// ------------------------------------
// Constants
// ------------------------------------
export const CUSTOMURLS_POST_REQUEST = "CUSTOMURLS_POST_REQUEST";
export const CUSTOMURLS_POST_REQUEST_SUCCESS =
  "CUSTOMURLS_POST_REQUEST_SUCCESS";
export const CUSTOMURLS_POST_REQUEST_FAILURE =
  "CUSTOMURLS_POST_REQUEST_FAILURE";

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: CUSTOMURLS_POST_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(data) {
  return {
    type: CUSTOMURLS_POST_REQUEST_SUCCESS,
    data,
  };
}

export function requestFailure(error) {
  return {
    type: CUSTOMURLS_POST_REQUEST_FAILURE,
    error,
  };
}
